/*################################################################
                        Bootstrap
################################################################*/
window.Vue = require('vue');
window._ = require('lodash');

try {
    // safety loader
    if(!window.$) {
        window.$ = window.jQuery = require('jquery');
    }
} catch (e) {}

Vue.config.productionTip = false;


/*################################################################
                    Define all Components
################################################################*/
Vue.component('puzzle-hints', require('./components/PuzzleHints.vue').default);


/*################################################################
Due to script tags in the middle of the content we need to
initiate seperate components.
################################################################*/

if(document.getElementById('puzzle-hints')) {
    const body = new Vue({
        el: '#puzzle-hints'
    });
}

